module.exports = __webpack_public_path__ + "assets/align-to-bottom-icon.851f4dc0.svg";